import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import { InlineButton } from '../InlineButton';

export interface ICountDownProps {
  seconds: number;

  onClick(): void;
}

export const CountDown: React.FC<React.PropsWithChildren<ICountDownProps>> = ({ seconds, onClick }) => {
  return (
    <div>
      {seconds > 0 ? (
        <UIText2 color="gray40_100">Отправить код повторно через {seconds} сек.</UIText2>
      ) : (
        <InlineButton onClick={onClick}>Отправить код повторно</InlineButton>
      )}
    </div>
  );
};

CountDown.displayName = 'CountDown';
